/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * slider.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Imprt swiper.
 */
import Swiper from "swiper/bundle";

/**
 * Imprt CSS.
 */
import "swiper/css/bundle";

/**
 * 共通スライダー
 *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function defaultSlider() {
    if (document.getElementById('slider')) {
        var spaceBetween = 0
        window.matchMedia("(min-width: 1024px)").matches ? spaceBetween = 32 : spaceBetween = 20;
        const option = {
            loop: true,
            slidesPerView: 'auto',
            initialSlide: 0,
            centeredSlides: true,
            spaceBetween: spaceBetween,
            preventClicks: true,
            speed: 500,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            grabCursor: true,
            pagination: {
                el: '.slide-tool-box .perview__current',
                type: 'bullets',
                clickable: true,
            },
            navigation: {
                prevEl: '.button__prev',
                nextEl: '.button__next',
            },
        };

        const slider = new Swiper("#slider", option);

        var PerViewCurrent = document.querySelectorAll('.slide-tool-box .swiper-pagination-bullet');
        var PerViewAll = document.querySelectorAll('.slide-tool-box .perview__all');
        var Slides = document.querySelectorAll('.interview__box__card:not(.swiper-slide-duplicate)');

        PerViewAll[0].innerHTML = Slides.length;
        for (let i = 0; i < PerViewCurrent.length; i++) {
            PerViewCurrent[i].innerHTML = i + 1;
        }
    }
}

export {
    defaultSlider
};

/**
 * その他スライダー読み込み
 *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import './slider/other/other-sliders';